import styled from 'styled-components'

export const Container2 = styled.div`
    padding-bottom: ${props=>props.theme.rowPadding3}px;
`   

export const Container3 = styled.div`
    padding-bottom: ${props=>props.theme.rowPadding2}px;
`   